<template lang="html">
  <v-container class='fluid'>

    <!-- DIALOG PARA ADICIONAR REGISTRO -->
    <v-dialog v-model="dialogAdicionar" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-4">
          Registrar Envio de Relatório do Projeto
        </v-card-title>

        <v-card-text class="pt-4">
          <v-text-field
            v-model="idProjetoDigitado"
            label="Id do Projeto"
            type="number"
            outlined
            dense
            required
            disabled
          ></v-text-field>

          <v-text-field
            v-model="novoRegistro.dtEnvio"
            label="Data final do período"
            type="date"
            outlined
            dense
            required
          ></v-text-field>

          <v-text-field
            v-model="novoRegistro.numRelatorio"
            label="Número do relatório"
            type="number"
            outlined
            dense
            required
          ></v-text-field>

          <v-text-field
            v-model="novoRegistro.numProcesso"
            label="Número do Processo"
            outlined
            dense
            required
          ></v-text-field>

          <v-select label='Nova Situação do Projeto' :items="listaSituacoesPossiveis" v-model="novoRegistro.situacao"
            item-text="descricao" item-value="item" max-height="400" return-object required >
          </v-select>
          </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-end">
          <v-btn text @click="dialogAdicionar = false">Cancelar</v-btn>
          <v-btn color="primary" dark @click="registrarEnvio"
            :disabled="!novoRegistro.dtEnvio || !novoRegistro.numRelatorio || !novoRegistro.numProcesso || !novoRegistro.situacao">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>




    <!-- LAYOUT PRINCIPAL -->
    <v-layout align-center justify-center>
      <v-flex xs10>

        <v-card class="text-xs-center">
          <basic-toolbar :title="'Registros de Envio de Relatório de Projeto'"></basic-toolbar>

          <v-card-text>

            <!-- CAMPO PARA DIGITAR O ID DO PROJETO -->
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  label="ID do Projeto"
                  type="number"
                  outlined
                  v-model="idProjetoDigitado"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-btn color="primary" class="mt-4" @click="buscarRegistros">
                  Buscar Registros
                </v-btn>
              </v-col>

              <v-col cols="12" md="4">
                <v-btn
                  color="success"
                  class="mt-4"
                  :disabled="!idProjetoDigitado || idProjetoDigitado != idProjetoBuscado"
                  @click="abrirDialogAdicionar"
                >
                  Adicionar Registro
                </v-btn>
              </v-col>
            </v-row>

            <!-- TABELA DE REGISTROS -->
            <v-data-table
              :headers="headers"
              :items="listaRegistros"
              :no-data-text="'Nenhum registro encontrado'"
            >
            <!-- FORMATA A DATA -->
              <template v-slot:item.dtEnvio="{ item }">
                {{ formatarData(item.dtEnvio) }}
              </template>
              <!-- COLUNA DE AÇÕES (Editar / Excluir) -->
              <template v-slot:item.acoes="{ item }">
                <v-btn icon small color="primary" :disabled="idProjetoDigitado != idProjetoBuscado" @click="editarRegistro(item)">
                  <v-icon>edit</v-icon>
                </v-btn>

                <v-btn icon small color="red" :disabled="idProjetoDigitado != idProjetoBuscado" @click="excluirRegistro(item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>

          </v-card-text>

        </v-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import TootipButton from '@/components/c-tooltip-btn'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    data: () => ({
      idProjetoDigitado: null,
      idProjetoBuscado: null,

      listaRegistros: [],

      listaSituacoesPossiveis: [],

      dialogAdicionar: false,

      idRegistroEditando: null,

      novoRegistro: {
        dtEnvio: null,
        numRelatorio: null,
        numProcesso: null,
        situacao: null
      },

      headers: [
        { text: 'Data final do período', value: 'dtEnvio', align: 'center' },
        { text: 'Número do Relatório', value: 'numRelatorio', align: 'center' },
        { text: 'Processo', value: 'numProcesso', align: 'center' },
        { text: 'Nova Situação', value: 'situacao.descricao', align: 'center' },
        { text: 'Ações', value: 'acoes', align: 'center', sortable: false }
      ]
    }),

    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      buscarRegistros () {
        if (!this.idProjetoDigitado) return
        this.listaRegistros = []
        this.idProjetoBuscado = this.idProjetoDigitado

        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Buscando registros...' })

        projetos.getRegistrosDeEnvioDeRelatorioDeProjeto(this.idProjetoDigitado)
          .then(response => {
            this.listaRegistros = response.data
          })
          .catch(error => {
            this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem || 'Erro ao buscar' })
          })
          .finally(() => {
            this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Registrando Envio de Relatório...' })
          })
      },

      abrirDialogAdicionar () {
        this.idRegistroEditando = null // estamos criando
        this.novoRegistro = { dtEnvio: null, numRelatorio: null, numProcesso: null, situacao: null } // limpa o formulário
        this.dialogAdicionar = true
      },

      opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        return projetos.getOpcoesTabelaEstruturada(codTabela)
          .then(response => {
            aqui[atributo] = response.data.slice()
          })
          .catch(error => {
            console.log('Erro ao mandar o request' + error)
          })
          .finally(() => {
            this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
          })
      },

      registrarEnvio () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando registro...' })

        const payload = {
          dtEnvio: this.novoRegistro.dtEnvio,
          numRelatorio: this.novoRegistro.numRelatorio,
          numProcesso: this.novoRegistro.numProcesso,
          situacao: this.novoRegistro.situacao
        }

        let requisicao

        if (this.idRegistroEditando) {
          requisicao = projetos.putRegistroEnvioDeRelatorioDeProjeto(this.idProjetoBuscado, this.idRegistroEditando, payload)
        } else {
          requisicao = projetos.postRegistrarEnvioDeRelatorioDeProjeto(this.idProjetoBuscado, payload)
        }

        requisicao
          .then(response => {
            this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem })
            this.buscarRegistros()
          })
          .catch(error => {
            this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem })
          })
          .finally(() => {
            this.dialogAdicionar = false
            this.idRegistroEditando = null
            this.HIDE_GLOBAL_LOADING()
          })
      },

      formatarData (data) {
        if (!data) return ''

        const [ano, mes, dia] = data.split('-')

        return `${dia}/${mes}/${ano}`
      },

      restaurarFormatoOriginal (data) {
        if (!data) return null

        // Se já estiver no formato yyyy-MM-dd, mantenha
        if (/^\d{4}-\d{2}-\d{2}$/.test(data)) {
          return data
        }

        // Se estiver no formato dd/MM/yyyy → converter
        const [dia, mes, ano] = data.split('/')
        return `${ano}-${mes}-${dia}`
      },

      editarRegistro (item) {
        // Seta o ID que será editado
        this.idRegistroEditando = item.idRegistroRelatorioProjeto

        this.novoRegistro = {
          // dtEnvio: this.restaurarFormatoOriginal(item.dtEnvio),
          dtEnvio: item.dtEnvio,
          numRelatorio: item.numRelatorio,
          numProcesso: item.numProcesso,
          // situacao: this.listaSituacoesPossiveis.find(s => s.id === item.situacao)
          situacao: item.situacao
        }
        this.dialogAdicionar = true
      },

      excluirRegistro (item) {
        if (!confirm('Tem certeza que deseja excluir este registro?')) return

        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo...' })

        projetos.deleteRegistroEnvioDeRelatorioDeProjeto(this.idProjetoDigitado, item.idRegistroRelatorioProjeto)
          .then(() => {
            this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: 'Registro excluído com sucesso.' })
            this.buscarRegistros()
          })
          .catch(error => {
            this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem })
          })
          .finally(() => {
            this.HIDE_GLOBAL_LOADING()
          })
      }
    },
    mounted: function () {
      this.opcoesTabelaEstruturada(6011, this, 'listaSituacoesPossiveis')
      .then(() => {
        // mantém apenas itens 18,19,4,5,20 - apos Ticket #715925 mantém apenas itens 18(ATIVO), 19(CONCLUIDO), 4(SUSPENSO), 5(CANCELADO), 3(INADIMPLENTE))
        this.listaSituacoesPossiveis = this.listaSituacoesPossiveis.filter(
          (item) => item.item === 18 || item.item === 19 || item.item === 4 || item.item === 5 || item.item === 3
        )
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'c-tooltip-btn': TootipButton,
      'tooltip': ToolTip
    }
  }
</script>



// WEBPACK FOOTER //
// registro-envio-relatorios-projeto.vue?1b8ed028